module.exports = __webpack_public_path__ + "static/img/2.2ed030f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/4/2.png
// module id = GFWr
// module chunks = 1